module.exports = __webpack_public_path__ + "img/promo-link-sent-icon.3ed08c2e.svg";